import { render, staticRenderFns } from "./CompProtestos.vue?vue&type=template&id=4e5860b9&scoped=true&"
import script from "./CompProtestos.vue?vue&type=script&lang=js&"
export * from "./CompProtestos.vue?vue&type=script&lang=js&"
import style0 from "./CompProtestos.vue?vue&type=style&index=0&id=4e5860b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5860b9",
  null
  
)

export default component.exports